import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { AppHelperService } from '@offconon/shared/utils/services/app-helper';

@Component({
  selector: 'offconon-app-list-render',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, RouterModule],
  templateUrl: './app-list-render.component.html',
  styles: ``,
})
export class AppListRenderComponent implements OnInit {
  @Input() filter: any;
  @Input() settings: any = {};
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  // Default settings
  private defaultSettings = {
    title: true,
    icon: true,
    description: true,
    arrow: true,
    comingsoon: true,
    size: 'large',
    type: 'core',
  };

  apps_datas: any[] = [];
  app_infos: any[] = [];
  userType: string = 'business';

  constructor(public appHelperService: AppHelperService) {}

  ngOnInit() {
    this.settings = { ...this.defaultSettings, ...this.settings };

    if (this.settings?.type === 'core') {
      const searchData = this.appHelperService.getSearchHelper(this.filter);
      this.apps_datas = Array.isArray(searchData) ? searchData : [];
    } else if (this.settings?.type === 'business') {
      const moduleData = this.appHelperService.getModuleConfig();
      this.app_infos = Array.isArray(moduleData) ? moduleData : [];
    }
  }

  getErpUrl(url: string): string {
    return url.split('/cognitive-erp/')[1] || url;
  }
}
